// extracted by mini-css-extract-plugin
export default {"companyContainer":"LM-z","companyImage":"MM-z","container":"NM-z","heading":"OM-z","darkText":"PM-z","smallHeading":"QM-z","darkBackground":"RM-z","whiteBackground":"SM-z"};